import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from 'react-bootstrap/Modal'
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TextField from '@material-ui/core/TextField';
import TablePagination from '@material-ui/core/TablePagination';
import Button from '@material-ui/core/Button'
import TableRow from '@material-ui/core/TableRow';
import Clues from './Clues'
import Prove from './Prove'
import firebase from '../../Config/Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';
import { async } from 'q';


var count = 0

const columns = [

    { id: 'id', label: 'Group ID', minWidth: 30 },
    {
        id: 'password',
        label: 'Password',
        minWidth: 30,
        // align: 'right',
        format: value => value.toLocaleString(),
    },
    {
        id: 'actions',
        label: 'Actions',
        minWidth: 30,
        // align: 'right',
        format: value => value.toLocaleString(),
    },

];









const styles = theme => ({
    root: {
        width: '100%',
    },
    tableWrapper: {
        maxHeight: '83vh',
        overflow: 'auto',
    },
});




class App extends Component {

    constructor() {
        super()
        this.state = {
            showus: false,
            showuse: false,
            passch: false,
            newpass: "",
            data: [],
            loading: true,
            user: {},
            search: "",
            prevuser: "",
            prevpass: "",
            passload: false,
            error: "",
            page: 0,
            rowsperpage: 10,
            lastKeySaved: "",
            pghistory: [],
            pop: true,
            delete: false,
            deleting: false,
            nogroup: false,


        }
    }

    handleChangePage = (event, newPage) => {


        if (newPage > this.state.page && !(this.state.pghistory.includes(newPage))) {
            this.getdata2()
        }
        this.setState({ page: newPage }, () => {
            var pghistory = this.state.pghistory
            pghistory.push(newPage)
            //console.log(pghistory,"history")
            this.setState({ pghistory: pghistory })
        })
        this.setState({ showus: false })


    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsperpage: +event.target.value })
        this.setState({ page: 0 })
    }




    componentDidMount() {

        this.setState({ data: [] }, () => {
            this.getdata();
        })




    }

    componentWillReceiveProps(props) {
        //console.log(props.status,"statuspage")
        this.setState({ data: [] }, () => {
            this.getdata();
        })
    }

    setmodal = (v) => {
        this.setState({ showus: true })
        this.setState({ showuse: false })
        this.setState({ user: v })
    }

    componentWillReceiveProps(props) {
        //console.log("recieved", props.value)
        this.setState({ showus: props.value })
        this.setState({ showuse: props.value })
        this.setState({ search: props.search })
    }


    getdata = () => {
        var count = 0
        firebase.database().ref("group").on("value", (snap) => {
            if (snap.exists()) {
                //console.log("exitsts")

                firebase.database().ref("group").orderByKey().startAt(this.state.lastKeySaved).limitToFirst(20).on("child_added", (snapshot) => {


                    var obj = {
                        groupId: snapshot.val().groupId,
                        groupPassword: snapshot.val().groupPassword,
                        id: snapshot.key
                    }


                    const previousList = this.state.data;
                    previousList.push(obj)

                    this.setState({
                        data: previousList,
                        lastKeySaved: obj.id
                    }, () => {
                        this.setState({ loading: false })


                    });







                    //console.log(this.state.data)

                })
            }
            else {
                this.setState({ nogroup: true })
                this.setState({ loading: false })

            }
        })








    }


    getdata2() {
        count = 0
        firebase.database().ref("group").on("value", (snap) => {
            if (snap.exists()) {
                //console.log("exitsts")

                firebase.database().ref("group").orderByKey().startAt(this.state.lastKeySaved).limitToFirst(21).on("child_added", (snapshot) => {


                    var obj = {
                        groupId: snapshot.val().groupId,
                        groupPassword: snapshot.val().groupPassword,
                        id: snapshot.key
                    }

                    if (count > 0) {

                        const previousList = this.state.data;
                        previousList.push(obj)

                        this.setState({
                            data: previousList,
                            lastKeySaved: obj.id
                        }, () => {
                            this.setState({ loading: false })


                        });
                    }

                    count = count + 1




                    //console.log(this.state.data)

                })
            }
            else {
                this.setState({ nogroup: true })
                this.setState({ loading: false })

            }
        })


    }



    delete(v) {
        this.setState({ deleting: true })
        var self = this
        var admin = localStorage.getItem("User")
        admin = JSON.parse(admin)
        var pass = ""
        firebase.database().ref(`group/${v.id}`).remove()
        firebase.database().ref(`clue/${v.id}`).remove()
        this.setState({ data: [], lastKeySaved: "", pop: false }, () => {
            this.getdata()
        })
        firebase.database().ref(`admin/${admin.user.uid}`).on('value', (snap) => {

            pass = snap.val().password
        })

        this.setState({ prevuser: admin.user }, () => {

            firebase.auth().signOut().then(() => {
                firebase.auth().signInWithEmailAndPassword(v.groupId + "@gmail.com", v.groupPassword).then((users) => {
                    var user = firebase.auth().currentUser;
                    user.delete().then(function () {
                        //console.log("deleted")

                        firebase.auth().signOut().then(() => {
                            firebase.auth().signInWithEmailAndPassword(admin.user.email, pass).then(() => {
                                self.setState({ delete: false, deleting: false })


                            })

                        })
                    }, function (error) {
                        //console.log(error)
                    });
                })

            })
        })


        this.setState({ showus: false })

    }



    makeadmin(userd) {
        this.setState({ passload: true })
        var admin = localStorage.getItem("User")
        admin = JSON.parse(admin)
        firebase.database().ref(`admin/${admin.user.uid}`).on('value', (snap) => {
            this.setState({ prevpass: snap.val().password })
        })
        this.setState({ prevuser: admin.user }, () => {
            firebase.auth().signOut().then(() => {
                firebase.auth().signInWithEmailAndPassword(userd.groupId + "@gmail.com", userd.groupPassword).then(() => {
                    var user = firebase.auth().currentUser
                    user.updatePassword(this.state.newpass).then(() => {
                        // alert("Password Was Changed")
                        firebase.auth().signOut().then(() => {
                            firebase.auth().signInWithEmailAndPassword(this.state.prevuser.email, this.state.prevpass).then((user) => {
                                //console.log(user.user.email)
                                firebase.database().ref(`group/${userd.id}`).update({
                                    groupPassword: this.state.newpass
                                }, () => {
                                    this.setState({ passload: false })
                                })
                                this.setState({ data: [], lastKeySaved: "", pop: false }, () => {
                                    this.getdata()
                                })
                                this.setState({ passch: false })
                            })

                        })

                    }).catch((err) => {
                        firebase.auth().signInWithEmailAndPassword(this.state.prevuser.email, this.state.prevpass)
                        this.setState({ passload: false })
                        this.setState({ error: err.message })
                        setTimeout(() => {
                            this.setState({ error: "" })
                        }, 3000);
                    })
                })
            })
        })


    }





    render() {




        const { classes } = this.props;
        return (
            <div>

                <Paper className={classes.root}>
                    <div className={classes.tableWrapper}>

                        <Table stickyHeader>

                            <TableHead className="tablehead" >
                                <TableRow className="tablehead" >
                                    {columns.map(column => (

                                        <TableCell className="tablehead"
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            {column.label}
                                        </TableCell>



                                    ))}

                                </TableRow>
                            </TableHead>

                            <TableBody>

                                {this.state.data.slice(this.state.page * this.state.rowsperpage, this.state.page * this.state.rowsperpage + this.state.rowsperpage).map((v) => {
                                    if (v.groupId.includes(this.state.search)) {
                                        return (


                                            <TableRow>

                                                <TableCell>
                                                    {v.groupId}
                                                </TableCell>
                                                <TableCell>
                                                    {v.groupPassword}
                                                </TableCell>


                                                <TableCell>
                                                    <div style={{ zIndex: "-1" }}>
                                                        <button className="btn btn-primary" onClick={() => { this.setmodal(v) }}>Clues</button>
                                                        <button className="btn btn-warning" style={{ marginLeft: "0.5vw" }} onClick={() => { this.setState({ passch: true }); this.setState({ showus: false }); this.setState({ user: v }) }}>Change Password</button>
                                                        <button className="btn btn-danger" style={{ marginLeft: "0.5vw" }} onClick={() => { this.setState({ delete: true, user: v, showus: false }) }}>Delete</button>
                                                    </div>

                                                </TableCell>
                                            </TableRow>


                                        )
                                    }

                                })}
                            </TableBody>
                        </Table>
                        {this.state.nogroup && <div style={{ width: "100%", textAlign: "center", marginTop: "20vh" }}>
                            <h6 style={{ fontFamily: "Roboto", color: "#000080" }}>No Groups Found</h6><h6 style={{ fontFamily: "Roboto", color: "#000080" }}>Create New From Add Group Menu</h6></div>}
                    </div>
                    {this.state.nogroup === false && <TablePagination
                        rowsPerPageOptions={[10, 15]}
                        component="div"
                        count={this.state.data.length}
                        rowsPerPage={this.state.rowsperpage}
                        page={this.state.page}
                        backIconButtonProps={{
                            'aria-label': 'previous page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'next page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />}

                </Paper>

                {this.state.loading && <div style={{ width: "100%" }}><CircularProgress style={{ marginTop: "20vh" }} className={classes.progress} /></div>}


                <Modal

                    show={this.state.passch}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                //  backdrop={"static"}
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Change Password
           </Modal.Title>
                    </Modal.Header>
                    {this.state.passload ? (<div style={{ textAlign: "center" }}><CircularProgress style={{ marginTop: "7vh", marginBottom: "10vh" }} className={classes.progress} />
                        <p style={{ color: "#000080", fontFamily: "Roboto" }}>Changing Password</p></div>) :
                        (<Modal.Body style={{ height: "25vh" }}>
                            <form className="md-form">


                                <TextField
                                    onChange={(e) => { this.setState({ newpass: e.target.value }) }}
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="password"
                                    label="New Password"
                                    name="password"

                                    autoFocus
                                /><br />
                                <div style={{ textAlign: "center" }}>
                                    <button className="btn btn-primary" onClick={() => { this.makeadmin(this.state.user) }} type="button">Change Password</button>
                                    {this.state.error && <div style={{ color: "#000080", fontFamily: "Roboto" }}><p>{this.state.error}</p></div>}
                                </div>
                            </form>
                        </Modal.Body>)}
                    <Modal.Footer>

                        {this.state.passload === false && <button onClick={() => { this.setState({ passch: false }) }} className="btn btn-danger">Close</button>}
                    </Modal.Footer>
                </Modal>






                <Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    show={this.state.delete}
                    size='md'
                    onHide={() => { this.setState({ delete: false }) }}>
                    <Modal.Header>
                        <Modal.Title>Delete User</Modal.Title>
                    </Modal.Header>
                    {this.state.deleting === false && <div><Modal.Body style={{ height: "10vh" }}><p>Are You Sure You Want To Delete <b>{this.state.user.groupId}</b>?</p></Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-primary" onClick={() => { this.setState({ delete: false }) }}>
                                Close
          </button>
                            <button className="btn btn-danger" onClick={() => { this.delete(this.state.user) }}>
                                Delete
          </button>
                        </Modal.Footer></div>}
                    {this.state.deleting && <div style={{ width: "100%", textAlign: "center" }}><CircularProgress style={{ marginTop: "5vh" }} className={classes.progress} />
                        <p style={{ fontFamily: "Roboto", color: "#000080" }}>Deleting...</p></div>}
                </Modal>



                <div style={{ display: "none" }}>
                    <Clues
                        open={this.state.showus}
                        onHide={() => { this.setState({ showus: false }) }}
                        user={this.state.user}

                    />
                </div>

                {/* <Prove
                        opens={this.state.showuse}
                        onHide={() => { this.setState({ showuse: false }) }}
/> */}


            </div>


        )
    }
}

export default withStyles(styles)(App);